import { stableSiteImagePath } from "@/data/stableSiteImages";
import { useMemo } from "react";
import useOwnedPhotoSchemas from "@/hooks/useOwnedPhotoSchemas";
import { makeProjectBatchSchemas } from "@/data/projectBatchImages";

const photoAssets = import.meta.glob([
  "/src/assets/1-wood-custom-line-8-inch-white-oak-plymouth-mi.webp",
  "/src/assets/ann-arbor-tech-floor-detail.webp",
  "/src/assets/ann-arbor-tech-lobby.webp",
  "/src/assets/ann-arbor-tech-open-floor.webp",
  "/src/assets/ann-arbor-tech-staircase.webp",
  "/src/assets/ann-arbor-tech-staircase-aerial.webp",
  "/src/assets/ann-arbor-tech-staircase-levels.webp",
  "/src/assets/bare-plywood-subfloor-evaluation-1-wood-floors-northville-mi.webp",
  "/src/assets/commercial-ann-arbor.webp",
  "/src/assets/custom-8-inch-hickory-hardwood-michigan-plank-fireside.webp",
  "/src/assets/deep-self-leveling-underlayment-pour-ann-arbor-mi.webp",
  "/src/assets/engineered-self-leveling-underlayment-concrete-livonia.webp",
  "/src/assets/harbor-springs-invisible-maple-vaulted.webp",
  "/src/assets/harbor-springs-maple-doorway.webp",
  "/src/assets/harbor-springs-maple-great-room.webp",
  "/src/assets/harbor-springs-maple-hallway.webp",
  "/src/assets/harbor-springs-maple-hallway-vaulted.webp",
  "/src/assets/harbor-springs-maple-staircase.webp",
  "/src/assets/harbor-springs-maple-staircase-aerial.webp",
  "/src/assets/harbor-springs-maple-turret.webp",
  "/src/assets/hepa-vacuum-dust-control-mixing-station-1-wood-floors.webp",
  "/src/assets/needle-rolling-self-leveling-underlayment-1-wood-floors-northville.webp",
  "/src/assets/northville-walnut-dining-chandelier.webp",
  "/src/assets/northville-walnut-fireplace-wide.webp",
  "/src/assets/northville-walnut-great-room-fireplace.webp",
  "/src/assets/northville-walnut-kitchen-island.webp",
  "/src/assets/northville-walnut-open-floor-kitchen.webp",
  "/src/assets/northville-walnut-slu-craftsman.webp",
  "/src/assets/northville-walnut-slu-pour.webp",
  "/src/assets/plymouth-custom-white-oak-aerial-seating.webp",
  "/src/assets/plymouth-custom-white-oak-floor-detail.webp",
  "/src/assets/plymouth-custom-white-oak-kitchen-island.webp",
  "/src/assets/plymouth-custom-white-oak-kitchen-range.webp",
  "/src/assets/plymouth-custom-white-oak-living-room.webp",
  "/src/assets/plymouth-custom-white-oak-stair-detail.webp",
  "/src/assets/schonox-collomix-subfloor-leveling-1-wood-floors.webp",
  "/src/assets/specialized-blue-subfloor-primer-1-wood-floors.webp",
  "/src/assets/subfloor-bonding-primer-over-mastic-livonia-mi.webp"
], { eager: true, import: "default", query: "?url" });

export default function useProjectBatchPhotos(path: string) {
  const schemas = useMemo(() => makeProjectBatchSchemas(path, (name: string) => {
    const src = stableSiteImagePath(name) ?? photoAssets[`/src/assets/${name}.webp`];
    return typeof src === "string" ? `https://1woodfloors.com${src}` : undefined;
  }), [path]);
  useOwnedPhotoSchemas(schemas);
}
